import { Component, Input } from '@angular/core';

import { DxScrollViewComponent } from 'devextreme-angular/ui/scroll-view';

@Component({
  selector: 'app-single-card',
  templateUrl: './single-card.component.html',
  styleUrls: ['./single-card.component.scss'],
  imports: [DxScrollViewComponent],
  standalone: true,
})
export class SingleCardComponent {
  @Input()
    title: string;

  @Input()
    description: string;

}
